import clsx from 'clsx';
import { type FunctionComponent, ReactElement, isValidElement } from 'react';

import { Typography } from '../typography/Typography';

type Props = {
  children: ReactElement<any>;
  iconLeft?: FunctionComponent;
  iconRight?: FunctionComponent;
  size?: 'default' | 'small';
  isOnDark?: boolean;
  fullWidth?: boolean;
  warning?: boolean;
};

/**
 * Een tekst button component.
 *
 * Wordt gebruikt voor de Sluit / Filter knoppen. Niet voor links.
 */
export const TextButton = (
  {
    children,
    iconRight: IconRight,
    size = 'default',
    isOnDark = false,
    fullWidth = false,
    warning,
  }: Props,
) => {
  const text = isValidElement(children) ? (children.props as any).children : '';
  const isDisabled = (children.props as any).disabled;

  const wrapperClasses = clsx('group flex w-fit items-center', {
    'underline-offset-4 hover:underline': !isDisabled,
    'text-textlink-enabled-on-light': !isDisabled && !isOnDark && !warning,
    'text-textlink-enabled-on-dark': !isDisabled && isOnDark,
    'text-textlink-disabled-on-light': isDisabled && !isOnDark,
    'text-textlink-disabled-on-dark': isDisabled && isOnDark,
    'w-full justify-between': fullWidth,
    'text-error': warning,
  });

  return (
    <children.type
      {...(children.props as any)}
      className={wrapperClasses}
    >
      <Typography
        type="span"
        variant={size === 'default' ? 'label-large' : 'label-regular'}
      >
        {text}
      </Typography>
      {IconRight && (
        <span
          className={clsx(
            'ml-1',
            size === 'default' && 'size-6',
            size === 'small' && 'size-5',
          )}
        >
          <IconRight />
        </span>
      )}
    </children.type>
  );
};
